
import React from 'react';
import ReactDOM from 'react-dom';
import './SliderCSS.css';

class SliderComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            images: [],
        };

        const isSpanish = window.location.pathname.slice(0,4) === '/es' || window.location.pathname.slice(0,4) === '/es/';
        const culture = isSpanish ? 'es' : 'en';
        fetch(`/api/default/images?$filter=FolderId%20eq%204ffcfda0-0c49-6a75-a385-ff1400f4265d&$orderby=Ordinal&sf_culture=${culture}`)
            .then((req) => req.json())
            .then(j => {
                return j.value.map(item => {
                    return {
                        image: process.env.NODE_ENV ==='development' || window.location.port === '8552' ? item.Url : item.Url.includes('https') ? item.Url : item.Url.replace('http','https'),
                       // image: window.location.protocol === 'http:' ? item.Url.replace("http", "https") : item.Url,
                        redirect: item.URLRedirect === '' ? null : item.URLRedirect
                    }
                })
            }).then(images => this.setState(Object.assign(this.state, {images: images}))).catch(e => console.log(e))

    }

    render() {
        return (
            <div>

                <div id="newsSlider" className="carousel slide mx-md-0" data-ride="carousel">
                    <ol className="carousel-indicators">
                        {this.state.images.map((item, idx) => {
                            return <li key={idx} data-target="#newsSlider" className={idx === 0 ? 'active' : ""}
                                       data-slide-to={idx}/>
                        })}

                    </ol>
                    <div className="carousel-inner">
                        {this.state.images.map((item, idx) => {
                            return item.redirect === null ?
                                <div key={idx} className={idx === 0 ? "carousel-item active" : "carousel-item"}>
                                    <img className="d-block w-100" src={item.image} alt="First slide"/>
                                </div> :
                                <div key={idx} className={idx === 0 ? "carousel-item active" : "carousel-item"}>
                                    <a href={item.redirect}>
                                        <img className="d-block w-100" src={item.image} alt="First slide"/>
                                    </a>
                                </div>
                        })}

                    </div>
                    <a className="carousel-control-prev" href="#newsSlider" role="button"
                       data-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"/>
                        <span className="sr-only">Previous</span>
                    </a>
                    <a className="carousel-control-next" href="#newsSlider" role="button"
                       data-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"/>
                        <span className="sr-only">Next</span>
                    </a>
                </div>

            </div>
        )
    }
}


let domContainer = document.querySelector('#slider_widget');
if (!(domContainer === undefined || domContainer === null) === true ) ReactDOM.render(<SliderComponent/>, domContainer);
